module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/graff.c6a0add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/graff.jpg
// module id = Du3R
// module chunks = 0